import { Box, Button, Typography } from '@mui/material';
import { Headline } from 'components/@shared/Headline';
import { ONLY_ADMIN } from 'constants/roles';
import { useDeniedAccess } from 'hooks/useDeniedAccess';
import { useDidMount } from 'hooks/useDidMount';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';

export const AdminSettingsPage = () => {
    const navigate = useNavigate();

    const handleGoToHomePages = useCallback(() => {
        navigate(PATH.ADMIN_SETTINGS_HOME_PAGE);
    }, []);

    useDidMount(() => {
        // TODO add api calls
    });

    useDeniedAccess(ONLY_ADMIN);

    return (
        <Box px={2.5} py={2}>
            <Headline title="Settings" />
            <Button onClick={handleGoToHomePages} variant="outlined">
                Home Page settings
            </Button>
        </Box>
    );
};
